import React from 'react'

interface FileUploaderProps {
  selectedFile: File | null
  previewUrl: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  currentImageUrl?: string
}

const FileUploader: React.FC<FileUploaderProps> = ({
  selectedFile,
  previewUrl,
  onChange,
  currentImageUrl
}) => {
  const imageUrl = previewUrl || currentImageUrl

  return (
    <div className='file-uploader'>
      <div className='form-group mb-3'>
        <label htmlFor='image'>Obrazek produktu</label>
        <div className='profile-image-upload'>
          <div className='profile-image-preview mb-20'>
            {imageUrl
              ? (
                <img
                  src={imageUrl}
                  alt='Podgląd obrazu'
                  className='img-fluid rounded'
                  style={{ maxHeight: '150px', display: 'block', margin: '0 auto' }}
                />
                )
              : (
                <div className='text-center p-3 bg-light rounded'>
                  <p>Brak zdjęcia</p>
                </div>
                )}
          </div>
          <div className='input-group'>
            <input
              type='file'
              className='form-control'
              id='image'
              name='image'
              accept='image/*'
              onChange={onChange}
            />
          </div>
        </div>
        <small className='form-text text-muted'>
          Wybierz obraz w formacie JPG, PNG lub WebP. Maksymalny rozmiar: 2MB.
        </small>
      </div>
    </div>
  )
}

export default FileUploader
